import React from 'react';
import PropType from 'prop-types';

const FormDetailsItem = ({ label, value, className }) => (
  <div className="row">
    <div className="col col-md-3">
      <label htmlFor="dsad" className="form-control-label">{label}</label>
    </div>
    <div className={`col-12 col-md-9 ${className}`}>
      {value}
    </div>
  </div>
);

FormDetailsItem.defaultProps = {
  className: '',
  value: '',
};

FormDetailsItem.propTypes = {
  label: PropType.string.isRequired,
  value: PropType.oneOfType([PropType.any]),
  className: PropType.string,
};

export default FormDetailsItem;
